import React from 'react';
import cn from 'classnames';
import { observer } from 'mobx-react';
import { IntlShape } from 'react-intl';
import { MeetingConnectionsTemplatesVM } from './connections-templates.viewmodel';
import { FormField } from '../../../../../global/form/form-field/form-field';
import DefaultButton from '../../../../../global/default-button/default-button';
import loadingIcon from '../../../../../../images/icons8-loading.gif';

import './connections-templates.scss';
import { ViewBlueprintDetailsSection } from '../../../shared/view-blueprint-details-section/view-blueprint-details-section';

export interface IConnectionTemplatesProps {
    vm: MeetingConnectionsTemplatesVM;
    intl: IntlShape;
}

const MeetingConnectionsTemplates = ({
    vm,
    intl,
}: IConnectionTemplatesProps) => {
    const isSingleConnection = vm.blueprintConnectionsAmount === 1;

    const generationText = isSingleConnection
        ? intl.formatMessage({
            id: 'oe.titles.oneConnectionIsBeingGenerated',
            description: 'Label',
            defaultMessage: '1 connection is being generated….'
        })
        : intl.formatMessage({
            id: 'oe.titles.connectionsAreBeingGenerated',
            description: 'Label',
            defaultMessage: '{connectionsAmount} connections are being generated….'
        }, {
            connectionsAmount: vm.blueprintConnectionsAmount
        })
    ;


    return (
        <div className='connection-template-actions'>
            <FormField
                label={intl.formatMessage({
                    id: 'oe.titles.connectionsTemplate',
                    description: 'Label',
                    defaultMessage: 'Connection Template',
                })}
            >
                <select
                    id='connections-template-selector'
                    className='oe-form-field__control'
                    value={vm.blueprintId}
                    onChange={e => vm.generatingConnections ? undefined : vm.selectBlueprint(e.target.value)}
                    disabled={vm.generatingConnections}
                >
                    <option value=''>
                        {intl.formatMessage({
                            id: `oe.templates.noTemplateSelected`,
                            description: 'Label text',
                            defaultMessage: 'No Template Selected',
                        })}
                    </option>
                    {
                        vm.getBlueprintsOptions().map(({ blueprintId, name }) => {
                            return <option value={blueprintId} key={blueprintId}>{name}</option>;
                        })
                    }
                </select>
            </FormField>
            <ViewBlueprintDetailsSection
                blueprintDetails={vm.getSelectedBlueprintDetails()}
                blueprintItemType={vm.getSelectedBlueprintType()}
            />
            { vm.shouldRenderGenerateSection() &&
                <div className={cn('generate-connections', {
                    'generate-connections__generating': vm.generatingConnections
                })}>
                    {vm.generatingConnections
                        ? <div className='generate-connections__loading'>
                            <img src={loadingIcon} alt='generating' />
                            { generationText }
                        </div>
                        : <div>
                            <div className='generate-connections__alert'>Connections have not been generated yet.</div>
                            <DefaultButton
                                text={intl.formatMessage({
                                    id: 'oe.button.generateConnectionsNowTitle',
                                    defaultMessage: `Generate {blueprintConnections} Connection${!isSingleConnection ? 's' : ''} Now`,
                                    description: 'Label text',
                                }, {
                                    blueprintConnections: vm.blueprintConnectionsAmount
                                })}
                                onClick={vm.generateConnections}
                                modifier={['fat', 'confirm-safe']}
                                disabled={vm.shouldDisableGenerateButton()}
                            />
                        </div>
                    }
                </div>
            }
        </div>
    );
};

export default observer(MeetingConnectionsTemplates);